<div class="outer-div">
  <div>
    <router-outlet/>
  </div>
</div>
